// Import and set jQuery
global.$ = global.jQuery = require('jquery');

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./components/Example');

require('bootstrap-datepicker/dist/js/bootstrap-datepicker')

require('slick-carousel/slick/slick')

require('image-map-resizer')

// Setup all the tooltips
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
    console.log('App js ready 🚀');
})

